<template>
    <div>
      <div class="center mt-5 px-3">
        <!-- <router-link
          to="/"
          class="navbar-brand mobile-only"
        >
          <img
            src="../../assets/img/logo/enginehire logo thin dark 1.0 letterpaths.svg"
            alt=""
            height="55"
          >
        </router-link> -->
        <h3 class="mt-5">We're excited to meet you. (:</h3>
        <div style="">
          <p
            style="max-width: 800px; display: block; margin-left: auto; margin-right: auto;"
            class="px-2 mt-4 mb-4"
          >Do you know how Uber gets the best drivers pick up the most rides? They give them bonuses for completing a certain number of trips, getting great reviews, and generally being awesome. Your agency can do the same thing! Discover how you can integrate this technology into your process to encourage candidates to pick up more shifts, keep their availability up to date, clock in and out on time, get great reviews, refer their friends, and so much more! See for yourself exactly how some of the companies using Enginehire use it, and why they love it!</p>
          <p class="center mt-3">1.855.775.4473 | hello@enginehire.ca</p>
        </div>
        <div
          class="meetings-iframe-container mb-5"
          data-src="https://meetings.hubspot.com/aakash-goel/rewards-and-incentives-platform?embed=true"
        ></div>
        <!-- https://stackoverflow.com/questions/45047126/how-to-add-external-js-scripts-to-vuejs-components -->
        <script
          type="application/javascript"
          src="https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js"
        ></script>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    created() {
      // Scroll the window to top on load
      window.scrollTo(0, 0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
    },
  };
  </script>


// WEBPACK FOOTER //
// src/components/demobooking/BookDemoRewardsIncentives.vue